export default "__VITE_ASSET__DRqkYQ$O__"